// Validate max custom quantity

export const MAX_CUSTOM_QUANTITY = 500;
